// Reports whether an element has entered the viewport, latching true so the
// caller can defer work (such as a large image fetch) until it's first seen.
// Without IntersectionObserver (jsdom, old browsers) it reports true at once.

import { useCallback, useState } from 'react';

export function useInViewOnce<T extends Element>(): [(node: T | null) => (() => void) | undefined, boolean] {
  const [inView, setInView] = useState(() => typeof IntersectionObserver === 'undefined');

  const ref = useCallback((node: T | null) => {
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      setInView(true);
      observer.disconnect();
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, inView];
}
